import { useLocation, Navigate, Outlet } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { selectCurrentRole, selectCurrentId } from "../auth/authSlice"
import { useRefreshMutation } from "../auth/authApiSlice"
import { useEffect, useState } from "react"
import { showSpinner, hideSpinner } from "../../components/componentSlice"
import { useGetCrmIdByAdvisorIdMutation } from "../crm/crmApiSlice"
import { useGetBobFormIdMutation } from "./bobApiSlice"

const RequireBobForm = () => {
    const [bobFormIdLoaded, setBobFormIdLoaded] = useState(false)
    const [bobFormId, setBobFormId] = useState(null)
    const location = useLocation()
    const id = useSelector(selectCurrentId)
    const role = useSelector(selectCurrentRole)
    const dispatch = useDispatch()

    const [refresh, {
        isUninitialized,
        isLoading,
        isSuccess,
        isError,
        error
    }] = useRefreshMutation()

    const [getCrmIdByAdvisorId, { isLoading: isGetCrmLoading }] = useGetCrmIdByAdvisorIdMutation()
    const [getBobFormId, { isLoading: isGetBobFormIdLoading }] = useGetBobFormIdMutation()

    useEffect(() => {
        if(isLoading) {
            dispatch(showSpinner())
        } else{
            dispatch(hideSpinner())
        }
    }, [isLoading])

    useEffect(() => {
        const getBobId = async () => {
            try {
                if(role === "ADVISOR") {
                    const response = await getBobFormId(id).unwrap()
                    if(response) {
                        setBobFormId(response.id)
                    }
                }
            } catch(err) {
                console.log(err)
            } finally {
                setBobFormIdLoaded(true)
            }
        }

        if(role && id) {
            getBobId()
        }
    }, [id])

    if (!bobFormIdLoaded) {
        return null
    }

    return role === "ADVISOR" && !bobFormId
        ? <Navigate to="/dash/bob" state={{ from: location }} replace />
        : <Outlet />
}

export default RequireBobForm